import React from "react";
import {
  Avatar,
  Box,
  Grid,
  IconButton,
  Link,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import EmailIcon from "@mui/icons-material/EmailOutlined";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import GitHubIcon from "@mui/icons-material/GitHub";
import SchoolIcon from "@mui/icons-material/School";
import SyncIcon from '@mui/icons-material/Sync';

const sections = [
//   {
//     id: "about",
//     title: "TL;DR",
//     paragraphs: [
//       "My expertise is in protein engineering and chemical biology. I specialize in repurposing bacterial transcription regulators as new measurement tools to study and engineer protein-chemical interfaces."
//     ],
//   },
//   {
//     id: "research",
//     title: "Research Interests",
//     paragraphs: [
//       "Enzymes have the incredible ability to make virtually any chemical from thin air (literally!), but we still can't reliably engineer them due to the SLOW and EXPENSIVE methods we rely on to \
//       measure their function (like HPLC, or LC/MS). I am interested in developing a new class of measurement tools, called genetically-encoded biosensors, to bridge this gap by characterizing MILLIONS of enzymes in a single experiment.\
//       The BIG datasets generated using these methods can support computational models to better predict enzyme function from sequence. \
//       With designer enzymes, we can lower the cost and carbon footprint of medicine, and build more effective therapeutics.\
//       Along the way, we'll make biosensors useful as diagnostics for disease and pollutants.\
//         "
//     ],
//   },
//   {
//     id: "experience",
//     title: "Experience",
//     timeline: [
//       {
//         period: "2023 — Present",
//         role: "Postdoctoral Fellow",
//         org: "Harvard Medical School",
//         description:
//           "Leading a biosensor engineering subgroup. \
//           Developing a portable PFAS diagnostic.\
//           Generating large biosensor-chemical responses datasets.\
//           ML-guided protein engineering.",
//       },
//       {
//         period: "2022 — 2023",
//         role: "Visiting Researcher",
//         org: "National Institute of Standards and Technology",
//         description:
//           "Implemented a Massively Parallel Reporter Assay to measure dose responses for >300,000 biosensors to 3 chemicals.\
//           Currently expanding this work via a collaboration with NIST and The Align Foundation.",
//       },
//       {
//         period: "2016 — 2022",
//         role: "PhD Researcher",
//         org: "The University of Texas at Austin",
//         description:
//           "Designed directed evolution workflows to engineer biosensors for alkaloids and terpenes.\
//           Evolved plant enzymes using biosensor-enabled screening.\
//           Used oil-water emulsion selections to evolve an aminoacyl-tRNA synthetase.\
//           Built software for systematic biosensor design.",
//       },
//     ],
//   },
  {
    id: "education",
    title: "Affiliations",
    highlights: [
        {
            id: "HIVE",
            content: (
              <>
                <Link
                  href="https://synbiohive.org/about-us"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Fellow
                </Link>
                {" "} @ Synthetic Biology HIVE.
              </>
            ),
          },
        {
        id: "Wyss",
        content: (
          <>
            <Link
              href="https://wyss.harvard.edu/team/postdoctoral-fellow/simon-doelsnitz/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Fellow
            </Link>
            {" "} @ Wyss Institute.
          </>
        ),
      },
      {
      id: "Align",
      content: (
        <>
          <Link
            href="https://alignbio.org/resources/transcription-factors/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Project co-lead
          </Link>
          {" "} @ The Align Foundation.
        </>
      ),},
      {
        id: "Retna",
        content: (
          <>
            <Link
              href="https://retna.bio/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Founder
            </Link>
            {" "} @ Retna Bio Consulting.
          </>
        ),},
        {
            id: "BSS",
            content: (
              <>
                <Link
                  href="https://www.biosensorseminar.org/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Co-Founder
                </Link>
                {" "} @ Biosensor Seminar Series.
              </>
            ),}
    ],
  },
//   {
//     id: "publications",
//     title: "Selected Publications",
//     paragraphs: [
//       "List one or two cornerstone papers or preprints here with links. You can also note awards, fellowships, or invited talks that you want to spotlight. Replace this text with your own highlights.",
//     ],
//   },
];



export default function About() {
  return (
    <Box
      sx={{
        backgroundColor: "#faf8f5",
        minHeight: "100vh",
        py: { xs: 6, md: 10 },
        px: { xs: 2, sm: 4 },
      }}
    >
      <Grid container justifyContent="center">
        <Grid size={{ xs: 12, lg: 10, xl: 9 }}>
          <Grid container spacing={{ xs: 4, md: 6 }} justifyContent="center">
            <Grid size={{ xs: 12, sm:8, md: 4 }}>
              <Paper
                elevation={0}
                sx={{
                  p: { xs: 3, sm: 4 },
                  borderRadius: 4,
                  border: "1px solid rgba(15, 23, 42, 0.08)",
                  backgroundColor: "#ffffff",
                  position: { md: "sticky" },
                  top: { md: 64 },
                }}
              >
                <Stack spacing={3} alignItems="center">
                  <Stack spacing={2} alignItems="center" textAlign="center">
                    <Avatar
                      variant="rounded"
                      src="profile.jpg"
                      alt="Your portrait"
                      sx={{ width: 200, height: 200, borderRadius: 3 }}
                    />
                    <Box>
                      <Typography
                        variant="h4"
                        sx={{ fontFamily: "Inter", fontWeight: 600 }}
                      >
                        Simon d&apos;Oelsnitz
                      </Typography>
                      <Typography
                        variant="subtitle1"
                        sx={{
                          fontFamily: "Inter",
                          color: "text.secondary",
                          mt: 0.5,
                        }}
                      >
                        Synthetic Biology Fellow
                      </Typography>
                    </Box>
                  </Stack>


                  <Stack direction="row" spacing={1.5}>
                    <IconButton
                      aria-label="Email"
                      component={Link}
                      href="mailto:simonsnitz@gmail.com"
                      target="_blank"
                    >
                      <EmailIcon />
                    </IconButton>
                    <IconButton
                      aria-label="LinkedIn"
                      component={Link}
                      href="https://www.linkedin.com/in/simon-doelsnitz"
                      target="_blank"
                    >
                      <LinkedInIcon />
                    </IconButton>
                    <IconButton
                      aria-label="GitHub"
                      component={Link}
                      href="https://github.com/simonsnitz"
                      target="_blank"
                    >
                      <GitHubIcon />
                    </IconButton>
                    <IconButton
                      aria-label="Google Scholar"
                      component={Link}
                      href="https://scholar.google.com/citations?user=4lfhK5wAAAAJ&hl=en"
                      target="_blank"
                    >
                      <SchoolIcon />
                    </IconButton>
                    <IconButton
                      aria-label="Addgene"
                      component={Link}
                      href="https://www.addgene.org/Simon_d'Oelsnitz/"
                      target="_blank"
                    >
                        <SyncIcon/>
                    </IconButton>
                  </Stack>
                </Stack>
              </Paper>
            </Grid>


            <Grid size={{ xs: 12, md: 8 }}>
              <Stack spacing={{ xs: 4, md: 6 }}>


                <Grid>
                    <Typography
                      sx={{
                        fontFamily: "Monospace",
                        fontSize: 22,
                      }}
                    >
                      TL;DR
                    </Typography>

                      <Typography
                        sx={{
                          fontFamily: "Inter",
                          fontSize: 16,
                          lineHeight: 1.8,
                          mt:1.5
                        }}
                      >
                        My expertise is in protein engineering and chemical biology. I specialize in repurposing bacterial
                        transcription regulators as new measurement tools to study and engineer protein-chemical interfaces.

                      </Typography>
                </Grid>


                <Grid>
                    <Typography
                      sx={{
                        fontFamily: "Monospace",
                        fontSize: 22,
                      }}
                    >
                      Postdoc
                    </Typography>

                      <Typography
                        sx={{
                          fontFamily: "Inter",
                          fontSize: 16,
                          lineHeight: 1.8,
                          mt:1.5
                        }}
                      >
                        Since 2023 I have been a fellow in the Synthetic Biology <a href="https://synbiohive.org/about-us" target="__blank">HIVE</a> at Harvard Medical School leading a subgroup focused on 
                        developing genetically-encoded small molecule biosensors for human and planet health.
                        One project is developing a portable <a href="https://wyss.harvard.edu/technology/pfasense-fast-in-field-testing-for-forever-chemicals/" target="__blank">PFAS diagnostic</a> at the Wyss Institute, while another is creating 
                        <a href="https://qfastr.hms.harvard.edu/qfr/developing-synthetic-biology-platform-pharmaceutical-biomanufacturing" target="__blank"> drug-responsive sensors </a>
                         to accelerate enzyme engineering. Our protein engineer work combines genetic circuit design, directed evolution,
                        large-scale measurements, and <a href="https://evedesign.bio" target="__blank">machine learning</a> in highly collaborative projects with biophysicists, computational biologists,
                        metabolic engineers, and electrochemists.
                      </Typography>
                </Grid>


                <Grid>
                    <Typography
                      sx={{
                        fontFamily: "Monospace",
                        fontSize: 22,
                      }}
                    >
                      Graduate School & after
                    </Typography>

                      <Typography
                        sx={{
                          fontFamily: "Inter",
                          fontSize: 16,
                          lineHeight: 1.8,
                          mt:1.5
                        }}
                      >
                        From 2016-2021 I did my PhD in Molecular Biology at UT Austin under Andy Ellington and Hal Alper.
                        My work focused on the directed evolution of improved proteins, which I implemented using oil-water emulsion selections 
                        and my own custom growth-and-fluorescence based selections.
                        There, I evolved <a href="https://www.nature.com/articles/s41589-022-01072-w" target="__blank">biosensors</a> for terpenes and alkaloids, 
                        <a href="https://www.nature.com/articles/s41467-024-46356-y" target="__blank"> enzymes</a> for therapeutic plant metabolites,
                        aminoacyl-tRNA <a href="https://onlinelibrary.wiley.com/doi/abs/10.1002/anie.202100579" target="__blank">synthetases</a> for L-DOPA, 
                        and <a href="https://academic.oup.com/jimb/article/46/12/1715/5996814" target="__blank">transporters</a> for ionic liquid tolerance.
                        <br/><br/>
                        From 2021-2023 I started a collaborative project with a quantitative biology group at The National Institute of Standards and Technology.
                        I implemented a massively parallel reporter assay to measure the response of >300,000 biosensors to three pharmaceutical intermediates.
                        Around this time, I also started building several software tools for the systematic design of biosensors.
                      </Typography>
                </Grid>
        
                <Grid>
                    <Typography
                      sx={{
                        fontFamily: "Monospace",
                        fontSize: 22,
                      }}
                    >
                      Way back then
                    </Typography>

                      <Typography
                        sx={{
                          fontFamily: "Inter",
                          fontSize: 16,
                          lineHeight: 1.8,
                          mt:1.5
                        }}
                      >
                      From 2012-2016 I studied Pharmacology at Stony Brook University and worked as a part-time pharmacy technician.
                      In Martin Kaczocha's lab I helped study the role of protein-lipid interactions in prostate cancer metastasis.
                      I was also part of the 2015 iGEM team.

                      </Typography>
                </Grid>



                {sections.map((section) => (
                  <Box key={section.id}>
                    <Typography
                      sx={{
                        fontFamily: "Monospace",
                        fontSize: 22,
                      }}
                    >
                      {section.title}
                    </Typography>

                    {/* {section.paragraphs?.map((paragraph, index) => (
                      <Typography
                        key={index}
                        sx={{
                          fontFamily: "Inter",
                          fontSize: 16,
                          lineHeight: 1.8,
                          mt: index === 0 ? 2 : 1.5,
                        }}
                      >
                        {paragraph}
                      </Typography>
                    ))} */}

                    {section.highlights && (
                      <Stack component="ul" spacing={1.5} sx={{ mt: 2, pl: 3 }}>
                        {section.highlights.map((item) => {
                          const key = typeof item === "string" ? item : item.id;
                          const content =
                            typeof item === "string" ? item : item.content;

                          return (
                            <Typography
                              key={key}
                              component="li"
                              sx={{
                                fontFamily: "Inter",
                                fontSize: 16,
                                lineHeight: 1.7,
                              }}
                            >
                              {content}
                            </Typography>
                          );
                        })}
                      </Stack>
                    )}

                    {/* {section.timeline && (
                      <Stack spacing={3} sx={{ mt: 3 }}>
                        {section.timeline.map(
                          ({ period, role, org, description }) => (
                            <Paper
                              key={period + role}
                              elevation={0}
                              sx={{
                                borderRadius: 3,
                                border: "1px solid rgba(15, 23, 42, 0.08)",
                                p: { xs: 3, sm: 3.5 },
                              }}
                            >
                              <Typography
                                sx={{
                                  fontFamily: "Inter",
                                  fontSize: 12,
                                  letterSpacing: "0.08em",
                                  textTransform: "uppercase",
                                  color: "text.secondary",
                                }}
                              >
                                {period}
                              </Typography>
                              <Typography
                                sx={{
                                  fontFamily: "Inter",
                                  fontSize: 20,
                                  fontWeight: 500,
                                  mt: 1,
                                }}
                              >
                                {role}
                              </Typography>
                              <Typography
                                sx={{
                                  fontFamily: "Inter",
                                  fontSize: 16,
                                  color: "text.secondary",
                                  mt: 0.5,
                                }}
                              >
                                {org}
                              </Typography>
                              <Typography
                                sx={{
                                  fontFamily: "Inter",
                                  fontSize: 16,
                                  lineHeight: 1.7,
                                  mt: 1.5,
                                }}
                              >
                                {description}
                              </Typography>
                            </Paper>
                          ),
                        )}
                      </Stack>
                    )} */}


                  </Box>
                ))}
              </Stack>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}
